import { IStartupApi } from "@api/affair.int";
import { Box } from "@chakra-ui/react";
import { useVVApi } from "components/api";
import { useVVColors } from "components/appComponents";
import { useVVStore } from "components/store";
import { VizvCard, VizvCardContent, VizvCardHeader, VizvMainCol } from "components/vizvComponents";
import { AdminLayout, AdminLogsToConfirm } from "features/admin/Admin";
import { AffairAttachment, AffairDescription, AffairLayout } from "features/affair/Affair";
import { AffairCaptureMap } from "features/affair/AffairCaptureMap";
import { AffairCreate } from "features/affair/AffairCreate";
import { AffairEdit } from "features/affair/AffairEdit";
import { AffairVideoUpload } from "features/affair/AffairVideoUpload";
import { Ack } from "features/auth/Ack";
import { GuardContact, GuardDashboard, GuardLayout } from "features/auth/Guard";
import { UserAccount } from "features/auth/UserAccount";
import { UserForgottenPassChange } from "features/auth/UserForgottenPassChange";
import { Foundraising, Impresszum, Welcome1, WelcomeKikVagyunk, WelcomeLayout, WelcomeLegyTeIsVizvedo, WelcomeMitCsinalunk } from "features/education/Welcome";
import { VVGroup } from "features/group/Group";
import { MapToolsColumn } from "features/map/MapTools";
import { MapWrapper } from "features/map/MapWrapper";
import { ProfileConfirm, ProfileDashboard, ProfileGuardKindApprove, ProfileGuardKindSelector, ProfileLayout, ProfileMyLocation } from "features/profile/Profile";
import { ProfileAffairs } from "features/profile/ProfileAffairs";
import { useContext, useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router";
import { DeepLayoutCtx, IDeepLayoutCtx } from "./components/misc";
import { DeepAuthContext } from "./features/auth/DeepAuth";


export const App = () => {

	const store = useVVStore();
	const api = useVVApi();

	// ================================ STARTUP ==========================
	useEffect(() => {
		console.log('---->> startup', store.groupList.length);
		if (store.groupList.length > 0)
			return; // ezt csak dev módban töltögeti idegesítően???
		(async () => {
			try {
				console.log('---->> startup itt1');
				const resp = await api.fetchToast<IStartupApi>({ url: '/affair/startup', method: 'GET' });
				// --- user -----
				store.setMyProfile(resp.profile);
				// --- groups ----
				store.addGroupItems(resp.groups);

			} catch { }
		})();
	}, []);

	// ================================ WATCH RESIZE ==========================
	useEffect(() => {
		store.__viewSizeChanged();

		let resizeTimer: any = 0;
		const listener = () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				store.__viewSizeChanged()
			}, 300)
		};


		window.addEventListener('resize', listener);
		return () => {
			clearTimeout(resizeTimer);
			window.removeEventListener('resize', listener);
		}

	}, []);


	const [layoutCtx, setLayoutCtx] = useState<IDeepLayoutCtx>({
		editorElem: null
	});


	const location = useLocation();
	const nav = useNavigate();
	useEffect(() => {
		if (location.pathname === '' || location.pathname === '/')
			nav('/welcome');
	}, [location.pathname]);

	/*useEffect(() => {
		let x = document.getElementById('icon-for-str');
		if (x)
			console.log(x.outerHTML);
	
	}, []);*/

	const GuardRoutes = <>
		<Route index element={<GuardDashboard />} />
		<Route path='contact' element={<GuardContact />} />
	</>

	const AffairRoutes = <>
		<Route index element={<AffairDescription />} />
		<Route path='attachment/:attachmentKey' element={<AffairAttachment />} />
		<Route path='video' element={<AffairVideoUpload />} />
		<Route path='edit' element={<AffairEdit />} />
	</>;


	return <>
		<DeepLayoutCtx.Provider value={layoutCtx}>
			<Box className={'dv-layout-main '} display='flex' flexDir='column' width='100vw' alignItems='center'  >
				<Routes>
					<Route element={<MapWrapper />} >
						<Route path='/affair/:affairKey/capture-map' element={<AffairCaptureMap />} />
						<Route index element={<></>} />  {/* át lesz irányítva */}
						<Route path="ack/*" element={<Ack />} />

						<Route path='welcome' element={<WelcomeLayout />} >
							<Route index element={<Welcome1 />} />
							{/*<Route path='beta' element={<WelcomeBeta />} />*/}
							<Route path='mit_csinalunk' element={<WelcomeMitCsinalunk />} />
							<Route path='kik_vagyunk' element={<WelcomeKikVagyunk />} />
							<Route path='legyel_te_is_vizvedo' element={<WelcomeLegyTeIsVizvedo />} />
							<Route path='foundraising' element={<Foundraising />} />
						</Route>
						<Route path='impresszum' element={<Impresszum />} />
						<Route path='map' element={store.isMobile() ? <MapToolsColumn /> : <></>} />
						<Route path='affair/:affairKey' element={<AffairLayout />} >
							{AffairRoutes}
						</Route>
						<Route path='create' element={<AffairCreate />} />

						<Route path='/group' element={<VVGroup />} />
						<Route path='/group/region/:region' element={<VVGroup />} >
							<Route path='affair/:affairKey' element={<AffairLayout isDetail={true} />} >
								{AffairRoutes}
							</Route>
							<Route path='guard/:userKey' element={<GuardLayout isDetail={true} />} >
								{GuardRoutes}
							</Route>
						</Route>
						<Route path='guard/:userKey' element={<GuardLayout />} >
							{GuardRoutes}
						</Route>


						<Route path='profile' element={<ProfileLayout />} >
							<Route index element={<ProfileDashboard />} />
							<Route path='/profile/guard-set/kind' element={<ProfileGuardKindSelector />} />
							<Route path='/profile/guard-set/name' element={<ProfileGuardKindApprove />} />
							<Route path='/profile/guard-set/location' element={<ProfileMyLocation />} />
							<Route path='/profile/guard-set/confirm' element={<ProfileConfirm />} />
						</Route>
						<Route path='/user/account' element={<UserAccount />} ></Route>
						<Route path='/user/forgotten-pass-change/:token' element={<UserForgottenPassChange />} ></Route>
						<Route path='/user/first-password/:token' element={<UserForgottenPassChange />} ></Route>


						<Route path='/profile-affairs/:userKey' element={<ProfileAffairs />}>
							<Route path='affair/:affairKey' element={<AffairLayout isDetail={true} />} >
								{AffairRoutes}
							</Route>
							<Route path='guard/:userKey' element={<GuardLayout isDetail={true} />} >
								{GuardRoutes}
							</Route>							
						</Route>
						
						<Route path='/admin' element={<AdminLayout />} >
							<Route path='logs-to-confirm' element={<AdminLogsToConfirm />} >
								<Route path='affair/:affairKey' element={<AffairLayout isDetail={true} />} >
									{AffairRoutes}
								</Route>
							</Route>
						</Route>



						<Route path='*' element={
							<VizvMainCol>
								<VizvCard>
									<VizvCardHeader warning>404</VizvCardHeader>
									<VizvCardContent>Route not found</VizvCardContent>
								</VizvCard>
							</VizvMainCol>}
						/>

					</Route>
				</Routes>
			</Box >
		</DeepLayoutCtx.Provider>

		{/* ---------------------------------- preload images -----------------------------------------
		<Box position='absolute' right={0} top={0} bg='red' zIndex={1000} >
			x: {JSON.stringify(store.isMobile())}
		</Box>
 */}

	</>
}


